var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00391 16V4H2.00391V2H5.00391C5.5562 2 6.00391 2.44772 6.00391 3V15H18.4423L20.4423 7H8.00391V5H21.7231C22.2754 5 22.7231 5.44772 22.7231 6C22.7231 6.08176 22.7131 6.16322 22.6932 6.24254L20.1932 16.2425C20.082 16.6877 19.682 17 19.2231 17H5.00391C4.45163 17 4.00391 16.5523 4.00391 16ZM6.00391 23C4.89934 23 4.00391 22.1046 4.00391 21C4.00391 19.8954 4.89934 19 6.00391 19C7.10848 19 8.00391 19.8954 8.00391 21C8.00391 22.1046 7.10848 23 6.00391 23ZM18.0039 23C16.8993 23 16.0039 22.1046 16.0039 21C16.0039 19.8954 16.8993 19 18.0039 19C19.1085 19 20.0039 19.8954 20.0039 21C20.0039 22.1046 19.1085 23 18.0039 23Z",
    fill: "#AABBCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.815b0c5b461b85cfae4ff535efcdd7f0.svg";
export { ForwardRef as ReactComponent };